import React from 'react';
import { searchContext } from '../../../../context/Context';
import { ButtonInfoGeneContentProps } from '../../types';

export function ButtonInfoGeneContent({ value }: ButtonInfoGeneContentProps) {
  const { setGeneContent } = searchContext();

  const handleClick = () => {
    setGeneContent({ isActive: false, geneInfo: null });
    setTimeout(() => {
      setGeneContent({ isActive: true, geneInfo: value });
    }, 0);
  };

  return (
    <button
      type="button"
      className="btn btn-link p-0 ms-1"
      onClick={handleClick}
      style={{ fontSize: '0.8em', color: '#007bff', cursor: 'pointer' }}
      title="Show gene information"
    >
      <i className="fa fa-info-circle" aria-hidden="true"></i>
    </button>
  );
}